import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { KindeProvider } from "@kinde-oss/kinde-auth-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ApiClientSetup } from "./api/ApiClientSetup";
import { queryClient } from "./api/queryClient";
import { App } from "./App";
import { kinde, missingConfig } from "./config";
import { ConfigErrorPage } from "./pages/ConfigErrorPage";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {missingConfig.length > 0 ? (
      <ConfigErrorPage missing={missingConfig} />
    ) : (
      <KindeProvider {...kinde}>
        <QueryClientProvider client={queryClient}>
          <ApiClientSetup>
            <App />
          </ApiClientSetup>
        </QueryClientProvider>
      </KindeProvider>
    )}
  </StrictMode>,
);
